import { render, staticRenderFns } from "./wechatImageText.vue?vue&type=template&id=afa7f494&scoped=true&"
import script from "./wechatImageText.vue?vue&type=script&lang=ts&"
export * from "./wechatImageText.vue?vue&type=script&lang=ts&"
import style0 from "./wechatImageText.vue?vue&type=style&index=0&id=afa7f494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa7f494",
  null
  
)

export default component.exports